import { render, staticRenderFns } from "./shopNotice.vue?vue&type=template&id=08fbe24e&"
import script from "./shopNotice.vue?vue&type=script&lang=js&"
export * from "./shopNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports